import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'gen-test-list-item',
  templateUrl: './test-list-item.component.html',
  styleUrls: ['./test-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestListItemComponent implements OnInit {


  @Input() testRow: any;
  @Input() testColumn: any;

  constructor() {
  }

  ngOnInit() {
  }

  showTooltip(value, row, prop) {
    row[prop] = value;
  }

}
